import { Component } from '@angular/core';

@Component({
  selector: 'mti-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      TRAVEL IBEX made with <i class="fas fa-heart" style="color: red;"></i> by 
      <a href="https://www.costaricavirtual.com" target="_blank">Costa Rica Virtual</a>
    </span>
    <div class="socials" style="display:none;">
      <a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {

  constructor() {}

}
